import Collection from 'lib/client/collections/collection'

class Availabilities extends Collection{
    reset(options){
        return this.axios.put(`organizations/${this.props.currentOrganization.id}/availabilities/reset`, options);
    }
}

export default Availabilities;